"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InputMeasurement;
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["defaultValue", "onChange", "required"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/InputMeasurement/index.js";
function InputMeasurement(_ref) {
  var defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    required = _ref.required,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var handleChange = function handleChange(e) {
    var val = e.target.value;
    // Only allow numbers and decimals
    if (/^\d*\.?\d*$/.test(val)) {
      onChange(val); // send as string instead of parseFloat
    }
  };
  return /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    type: "number",
    step: "any",
    defaultValue: defaultValue,
    onChange: handleChange,
    required: required,
    className: "form-control"
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }));
}